export default __webpack_public_path__ + "static/media/external-link-icon.34d5f204.svg";